const SubTitle = () => ({
    epayment: {
        masaAktif: "",
        tipe: "",
        JikaKedaluwarsa: "",
        jenisEmoney: "",
    },
    reminder: {
        epayment: "",
        deposit: "",
        poin: "",
    },
    laporan: {
        sumberDana: "Tidak Ada",
        itemBiaya: "Tidak Ada",
    },
});

export default SubTitle;
